import * as types from './countryActionTypes';

export const selectCountry = countrySfId => ({
  type: types.SELECT_COUNTRY,
  countrySfId,
});



// WEBPACK FOOTER //
// ./src/store/country/countryActions.js